<template>
  <!-- 产能负荷 -->
  <div class="load">

    <table class="mytable">
      <thead>
        <tr>
          <th style="width:5%;">名称</th>
          <th v-for="(mon,index) in 15" :key="index">第{{index+1}}天</th>
          <th>
            <i @click="addRow" style="font-size: 1.2rem;font-weight: 600;cursor:pointer;position: relative;top: 0.1rem;color: #00ffff;" class="el-icon-circle-plus-outline"></i>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,i) in tableData" :key='i'>
          <td>
            <el-input v-model="item.proName" placeholder="请输入名称"></el-input>
          </td>
          <td v-for="(ite,index) in item.data" :key="index">
            <el-input v-model="item.data[index]"  type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" placeholder="请输入"></el-input>
          </td>
          <td style="width: 6rem;text-align: center;">
            <i @click="del(item, i)" class="el-icon-remove-outline" style="font-size: 1.2rem;line-height: 1.8rem;color: #f00;font-weight: 600;cursor: pointer;"></i>
          </td>
        </tr>
      </tbody>
    </table>

    <div style="margin-top: 2rem;">
      <el-button @click="save" size="small" type="primary">保存设置</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/produce/load'
export default {
  components: {},
  data() {
    return {
      tableData: [
      ],
    }
  },
  mounted() {
    this.getlist()    
  },
  methods: {
    addRow() {
      this.tableData.push({
        proName: '',
        data: ['','','','','','','','','','','','','','','',],
      })
    },
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {


            this.tableData = []
            for (const iterator of res.data.list) {
              this.tableData.push({
                id :iterator.id,
                proName :iterator.proName,
                data :JSON.parse(iterator.data),
              })
            }

          } else {
            this.$message.error(res.message)
          }
        })
    },
    save() {

      let formData = []
      for (const iterator of this.tableData) {
        formData.push({
          id :iterator.id,
          proName :iterator.proName,
          data :JSON.stringify(iterator.data),
        })
      }
      api.save(formData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.getlist()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    del(item, i) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {
          for (const iterator of this.tableData) {
            if (iterator.id === undefined) {
              return this.$message.warning(
                '还有未保存的数据,请先保存后再删除！'
              )
            }
          }

          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
              this.getlist()
            } else {
              this.$message.error(res.message)
            }
            this.getlist()
          })
        } else {
          this.tableData.splice(i, 1)
        }
      })
    },



  },
}
</script>

<style lang="less" scoped>
.load { padding-top: 10px;
}
</style>